<div class="wrapper mt-3 pb-6" [formGroup]="timesheetAndExpensesForm">
    <div class="row">
        <div class="col">
            <tabset type="pills" paceCoreTabsRole>
                <tab
                    [heading]="strings.timesheetHeading"
                    [customClass]="isTimesheetFormInvalid() ? 'invalid-timesheet-expense-tab' : ''"
                >
                    <pace-timesheet
                        [model]="model.timesheetEntries"
                        [readonly]="model.readonly"
                        [parentForm]="timesheetFormChildren"
                        (autoSaveTimesheetForm)="triggerAutoSaveTimesheet()"
                    ></pace-timesheet>
                </tab>
                <tab
                    [heading]="strings.expensesHeading"
                    *ngIf="model.expenses"
                    [customClass]="isExpenseFormInvalid() ? 'invalid-timesheet-expense-tab' : ''"
                >
                    <pace-expenses [model]="model" [parentForm]="expensesFormChildren"></pace-expenses>
                </tab>
            </tabset>
        </div>
    </div>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-column">
        <ul class="navbar-nav d-flex d-lg-none flex-column mx-auto">
            <li class="navbar-text" *ngIf="timesheetAndExpensesForm.invalid">{{ strings.invalidTimesheetMessage }}</li>
            <li class="navbar-text" *ngIf="model.readonly">{{ strings.submittedTimesheetMessage }}</li>
        </ul>

        <div class="d-flex align-items-center justify-content-between w-100">
            <ul class="navbar-nav d-none d-lg-flex flex-column mx-auto">
                <li class="navbar-text" *ngIf="timesheetAndExpensesForm.invalid">
                    {{ strings.invalidTimesheetMessage }}
                </li>
                <li class="navbar-text" *ngIf="model.readonly">{{ strings.submittedTimesheetMessage }}</li>
            </ul>
            <ul class="navbar-nav d-flex flex-row gap-3 ms-auto mb-3">
                <li class="nav-item">
                    <button
                        class="btn btn-secondary button-width"
                        type="button"
                        (click)="downloadTimesheetFromConcurrencyStore()"
                        [disabled]="
                            (isOnline$ | async) === false ||
                            downloadStatus() === timesheetSyncStatus.LOADING ||
                            uploadStatus() === timesheetSyncStatus.LOADING
                        "
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                statusButtonContent;
                                context: {
                                    status: downloadStatus(),
                                    label: strings.downloadButtonLabel,
                                }
                            "
                        >
                        </ng-container>
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="btn btn-secondary button-width"
                        type="button"
                        (click)="saveAndUploadTimesheetToConcurrencyStore()"
                        [disabled]="
                            (isOnline$ | async) === false ||
                            downloadStatus() === timesheetSyncStatus.LOADING ||
                            uploadStatus() === timesheetSyncStatus.LOADING
                        "
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                statusButtonContent;
                                context: {
                                    status: uploadStatus(),
                                    label: strings.uploadButtonLabel,
                                }
                            "
                        >
                        </ng-container>
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="btn btn-primary"
                        type="button"
                        (click)="submit()"
                        [disabled]="isTimesheetSendDisabled()"
                        translate="TIMESHEET_SAVE_TIMESHEET_TITLE"
                    ></button>
                </li>
                <ng-template #statusButtonContent let-status="status" let-label="label">
                    <ng-container [ngSwitch]="status">
                        <ng-container *ngSwitchCase="timesheetSyncStatus.LOADING">
                            <fa-icon [icon]="faLoading" [spin]="true"></fa-icon>
                        </ng-container>

                        <ng-container *ngSwitchCase="timesheetSyncStatus.SUCCESS">
                            {{ label }}
                            <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
                        </ng-container>

                        <ng-container *ngSwitchCase="timesheetSyncStatus.ERROR">
                            {{ label }}
                            <fa-icon [icon]="faExclamationTriangle" class="text-danger"></fa-icon>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            {{ label }}
                        </ng-container>
                    </ng-container>
                </ng-template>
            </ul>
        </div>
    </div>
</nav>
